exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftv-magneto-fullscreen {\n  width: 100%!important;\n  height: 100%!important;\n  max-width: none!important;\n  max-height: none!important;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// exports
